<template>
  <b-modal
    id="AddEncryptionKeyModal"
    class="modal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    @hidden="doCancel"
  >
    <template
      slot="modal-header"
      slot-scope="{ close }"
    >
      <h5>{{ title }}</h5>
      <button
        class="btn btn--close"
        @click="close()"
      >
        <font-awesome-icon
          :icon="['fal', 'times']"
          class="icon alt"
        />
      </button>
    </template>


    <form-component>
      <form
        novalidate="novalidate"
        @submit.prevent
      >
        <input-text
          id="name"
          v-model="name"
          v-validate="'required'"
          name="name"
          data-vv-name="name"
          data-vv-as="name"
          label="Name"
          type="text"
          required
          :error="errors.first('name')"
        />

        <input-text
          id="email"
          v-model="email"
          v-validate="'required|email'"
          name="email"
          data-vv-name="email"
          data-vv-as="email address"
          label="Email Address"
          type="email"
          required
          :error="errors.first('email')"
        />
        <input-text-area
          id="pgp_key"
          v-model="pgp_key"
          v-validate="'required'"
          name="pgp_key"
          data-vv-name="pgp_key"
          data-vv-as="PGP Encryption Key"
          label="PGP Encryption Key"
          placeholder="-----BEGIN PGP PUBLIC KEY BLOCK-----"
          rows="15"
          required
          :error="errors.first('pgp_key')"
        />
      </form>
    </form-component>

    <template
      slot="modal-footer"
    >
      <button
        class="btn"
        type="button"
        @click="doCancel()"
      >
        Cancel
      </button>
      <button
        class="btn btn--primary"
        type="button"
        :disabled="saving"
        @click="save()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>Save</span>
      </button>
    </template>
  </b-modal>
</template>

<script>
/* eslint-disable vue/require-default-prop */
import FormComponent from '@/components/FormComponent.vue';
import InputText from '@/components/inputs/InputText.vue';
import InputTextArea from '@/components/inputs/InputTextArea.vue';

export default {
  name: 'AddEncryptionKeyModal',
  components: {
    FormComponent,
    InputText,
    InputTextArea,
  },
  props: {
    doCancel: {
      type: Function,
    },
    doSave: {
      type: Function,
    },
  },
  data: () => ({
    company_id: undefined,
    device_id: undefined,
    title: '',
    name: '',
    email: '',
    pgp_key: '',
    saving: false,
  }),
  methods: {
    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.errors.clear();
          this.saving = true;
          this.doSave(
            {
              organization: this.organizationId,
              device: this.deviceId,
              name: this.name,
              email: this.email,
              pgp_key: this.pgp_key,
            },
          ).catch((e) => {
            if (e.status === 400) {
              this.$validator.errors.add({
                field: 'pgp_key',
                msg: e.body.error.message,
              });
            }
            this.saving = false;
          });
        }
      });
    },
    setModal(data) {
      this.saving = false;

      this.organizationId = data.organizationId;
      this.deviceId = data.deviceId;
      this.title = data.title;

      this.name = '';
      this.email = '';
      this.pgp_key = '';
    },
  },
};
</script>

<style scoped lang="scss">

</style>
